module.exports = __webpack_public_path__ + "static/img/xj.2d3c609a.png";